import React from 'react';
import { useSelector } from 'react-redux';
import { FaRegCircleUser } from 'react-icons/fa6';

const AdminProfile = () => {
  const user = useSelector(state => state?.user?.user);

  return (
    <div className='min-h-[calc(100vh-120px)] md:flex'>
      {/* Main content */}
      <main className='w-full h-full p-2'>
        <div className="container max-w-xl mx-auto p-5" style={{ marginLeft: '20px' }}> {/* Shift content to the left */}
          <div className="flex flex-col items-center mb-5">
            <h2 className="text-2xl font-bold mb-5">ملف المشرف</h2>
            <div className="flex flex-col items-center space-y-4">
              {/* Profile Image */}
              <div className='w-24 h-24 rounded-full overflow-hidden'>
                {user?.profilePic ? (
                  <img src={user?.profilePic} alt="Profile" className='w-full h-full object-cover' />
                ) : (
                  <FaRegCircleUser className='text-6xl text-gray-500' />
                )}
              </div>
              {/* User Name */}
              <div>
                <h3 className="text-xl font-semibold text-center">{user?.name}</h3>
              </div>
            </div>
          </div>

          {/* User Information */}
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold text-right">: البريد الالكتروني</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.email}</p>
            </div>

            <div>
              <h3 className="font-semibold text-right">: الصلاحيات</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.role}</p>
            </div>


              <div>
              <h3 className="font-semibold text-right">: المدينة</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.governorate || 'لا يوجد اسم محافظة متاح'}</p>
            </div>
           {user?.governorate==='طرابلس'&& <div>
              <h3 className="font-semibold text-right">: المنطقة</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.region || 'لا يوجد اسم منطقة متاح'}</p>
            </div>  
            }
            <div>
              <h3 className="font-semibold text-right">: عنوان المخزن </h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.shippingAddress || 'لا يوجد عنوان حالى'}</p>
            </div>

            <div>
              <h3 className="font-semibold text-right">: رقم الهاتف المحمول</h3>
              <p className="border rounded p-1 bg-gray-50 text-sm">{user?.mobileNumber || 'لا يوجد رقم هاتف محمول متاح'}</p>
            </div>


          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminProfile;
